import { useEffect } from "react";
import { Link } from "react-router-dom";
import "./page.css";
import "./home.css";

const circuits = [
  {
    to: "/safaris/northern-circuits",
    title: "Northern Circuit",
    text: "Serengeti, Ngorongoro, Tarangire, and Lake Manyara. The classic Tanzania safari loop.",
  },
  {
    to: "/safaris/southern-circuits",
    title: "Southern Circuit",
    text: "Ruaha, Nyerere, and Mikumi. Wilder parks with fewer vehicles.",
  },
  {
    to: "/safaris/beach-and-safari",
    title: "Beach and Safari",
    text: "Mainland game days shaped around a Zanzibar finish.",
  },
];

function Safaris() {
  useEffect(() => {
    document.title = "Safaris · Mirrorkhan Tours";
  }, []);

  return (
    <section className="page section-block">
      <div className="container">
        <div className="row mb-4 mb-lg-5" data-reveal="true">
          <div className="col-lg-8">
            <p className="eyebrow">Safaris</p>
            <h1 className="mb-3">Mainland safari days in Tanzania.</h1>
            <p className="page-lead mb-0">
              Private game days across the northern and southern circuits, with
              optional Zanzibar time after the bush.
            </p>
          </div>
        </div>

        <div className="row g-4">
          {circuits.map((circuit, index) => (
            <div
              className="col-md-4"
              key={circuit.to}
              data-reveal="true"
              data-reveal-delay={String(index * 90)}
            >
              <Link
                to={circuit.to}
                className="tour-list-item d-block text-decoration-none h-100"
              >
                <div className="tour-list-item__body">
                  <h2 className="h3 mb-2">{circuit.title}</h2>
                  <p className="mb-0">{circuit.text}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Safaris;
